import LocalPlayIcon from '@mui/icons-material/LocalPlay'
import { IconBox, type IconBoxProps } from 'settle-ui/components/IconBox/IconBox'

interface PromoCodeIconProps extends Omit<IconBoxProps, 'children'> {
  active?: boolean
}

export const PromoCodeIcon: Settle.FC<PromoCodeIconProps> = ({ active = true, ...props }) => (
  <IconBox {...props}>
    <LocalPlayIcon
      sx={{
        ...(active
          ? { color: (theme) => theme.tokens.ThemeColorCommonSecondary }
          : { color: (theme) => theme.tokens.ThemeColorCommonOnSurfaceTertiary }),
      }}
    />
  </IconBox>
)
